import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8db78932"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "session-registry" }
const _hoisted_2 = { class: "session-registry__header my-md-3 mt-3 mb-2" }
const _hoisted_3 = { class: "session-registry__title m-0" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Featured Webinars", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Past Sessions", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "mt-3 mb-2 session-registry__title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Featured Webinars", -1))
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "mt-3 mb-2 session-registry__title" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Past Sessions", -1))

import { onMounted, watch, ref, computed } from 'vue'
import WebinarList from '@/components/WebinarList'
import EbarSessionList from '@/components/EbarSessionList/EbarSessionList.vue'
import SessionList from '@/components/SessionList/SessionList.vue'
import PastSessionList from '@/components/PastSessionList/PastSessionList.vue'
import SessionRegistration from '@/components/SessionRegistration'
import SessionSearch from '@/components/SessionSearch'
import { useSessionRegistryStore } from '@/components/SessionRegistryStore'
import { SessionRegistryStore } from '@/components/SessionRegistryStore/SessionRegistryStore.interfaces'
import { useToast } from '@/components/BsToastQueueStore'
import { useEventBus } from '@vueuse/core'
import { registerSessionKey } from '@/config/events'
import BsCheckbox from '@/components/BsCheckbox/BsCheckbox.vue'
import locales from './SessionRegistry.locales.en.json'
import { MicroFilter } from '../SessionSearch/SessionSeach.interfaces'
import { useClassroomStudentService } from '@/components/ClassroomStudentService'
import { Coach, CourseTag, WithId } from '@/types/api'


export default /*#__PURE__*/_defineComponent({
  __name: 'SessionRegistry',
  setup(__props) {

const { sessionState, sessionActions }: SessionRegistryStore = useSessionRegistryStore()
const { showErrorToast } = useToast()
const showSessionRegistration = ref(false)
const editSessionEventBus = useEventBus(registerSessionKey)
const searchCriteria = ref('')
const microFilter = ref({ days: [], times: [], tags: [] } as MicroFilter)

const filteredEbarSessionsLength = ref(0)
const filteredSessionsLength = ref(0)
const filteredWebinarSessionsLength = ref(0)
const filteredPastSessionsLength = ref(0)

const showMySessionOnly = ref(false)
const showOpenSeatsOnly = ref(false)
const showWebinarsOnly = ref(false)
const showPastSessionOnly = ref(false)

const activeRegisteredSessionsCount = computed(() =>
  sessionState.sessions.filter(s => s.showRegistered && s.localEndDateTime > new Date()).length
)

const classroomStudentService = useClassroomStudentService()
let coaches = ref<(Coach & WithId)[]>([])
let courseTags = ref<(CourseTag)[]>([])

onMounted(async () => {
  sessionActions.loadSessions()
  coaches.value = await classroomStudentService.fetchAllCoaches()
  courseTags.value = await classroomStudentService.fetchActiveTags()
})

watch(
  () => sessionState.error,
  (message: string | undefined) => message && showErrorToast({ message })
)

editSessionEventBus.on(() => {
  showSessionRegistration.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(SessionSearch), {
      microFilter: microFilter.value,
      "onUpdate:microFilter": _cache[0] || (_cache[0] = ($event: any) => ((microFilter).value = $event)),
      "is-ebar": _unref(sessionState).isEBar,
      "course-tags": _unref(courseTags),
      sessions: _unref(sessionState).sessions,
      onSearchTextUpdated: _cache[1] || (_cache[1] = ($event: any) => (searchCriteria.value = $event))
    }, null, 8, ["microFilter", "is-ebar", "course-tags", "sessions"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, [
          _withDirectives(_createElementVNode("span", null, [
            _createElementVNode("span", null, _toDisplayString(_unref(locales).title), 1),
            (!_unref(sessionState).isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(filteredEbarSessionsLength.value) + ")", 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !showWebinarsOnly.value && !showPastSessionOnly.value && _unref(sessionState).isEBar]
          ]),
          _withDirectives(_createElementVNode("span", null, [
            _hoisted_5,
            (!_unref(sessionState).isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (" + _toDisplayString(filteredWebinarSessionsLength.value) + ")", 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, showWebinarsOnly.value && _unref(sessionState).isEBar]
          ]),
          _withDirectives(_createElementVNode("span", null, [
            (_unref(sessionState).isLSAT)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "LSAT Classroom Sessions"))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(locales).title), 1)),
            (!_unref(sessionState).isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, " (" + _toDisplayString(filteredSessionsLength.value) + ")", 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !showPastSessionOnly.value && !_unref(sessionState).isEBar]
          ]),
          _withDirectives(_createElementVNode("span", null, [
            _hoisted_10,
            (!_unref(sessionState).isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, " (" + _toDisplayString(filteredPastSessionsLength.value) + ")", 1))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, showPastSessionOnly.value]
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([
          'd-inline-flex justify-content-between ms-auto me-1',
          _unref(sessionState).isLSAT ? 'session-registry__tools-lsat' : 'session-registry__tools'
        ])
        }, [
          _createVNode(BsCheckbox, {
            modelValue: showMySessionOnly.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showMySessionOnly).value = $event)),
            mode: "pill",
            label: _unref(sessionState).isLSAT
            ? _unref(locales).registered_tag.replace('__length__', activeRegisteredSessionsCount.value)
            : _unref(locales).mySession_tag
          }, null, 8, ["modelValue", "label"]),
          (!_unref(sessionState).isEBar)
            ? (_openBlock(), _createBlock(BsCheckbox, {
                key: 0,
                modelValue: showPastSessionOnly.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showPastSessionOnly).value = $event)),
                mode: "pill",
                label: _unref(locales).pastSession_tag
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (!_unref(sessionState).isLSAT)
            ? (_openBlock(), _createBlock(BsCheckbox, {
                key: 1,
                modelValue: showOpenSeatsOnly.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showOpenSeatsOnly).value = $event)),
                mode: "pill",
                label: _unref(locales).openSeats_tag
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true),
          (_unref(sessionState).isEBar)
            ? (_openBlock(), _createBlock(BsCheckbox, {
                key: 2,
                modelValue: showWebinarsOnly.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showWebinarsOnly).value = $event)),
                mode: "pill",
                label: _unref(locales).webinar_tag.replace('__length__', _unref(sessionState).webinars.length)
              }, null, 8, ["modelValue", "label"]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      (_unref(sessionState).isEBar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(showWebinarsOnly.value ? 'd-none' : 'd-grid')
            }, [
              _createVNode(EbarSessionList, {
                sessions: _unref(sessionState).sessions,
                "search-criteria": searchCriteria.value,
                "micro-filter": microFilter.value,
                "is-loading": _unref(sessionState).isLoading,
                "is-ready": _unref(sessionState).isReady,
                disabled: _unref(sessionState).isRegistering,
                "show-my-session-only": showMySessionOnly.value,
                "show-open-seats-only": showOpenSeatsOnly.value,
                "course-tags": _unref(courseTags),
                onFilteredSessionListLengthUpdated: _cache[6] || (_cache[6] = ($event: any) => (filteredEbarSessionsLength.value = $event))
              }, null, 8, ["sessions", "search-criteria", "micro-filter", "is-loading", "is-ready", "disabled", "show-my-session-only", "show-open-seats-only", "course-tags"]),
              _createElementVNode("h5", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("span", null, " (" + _toDisplayString(filteredWebinarSessionsLength.value) + ") ", 513), [
                  [_vShow, !_unref(sessionState).isLoading]
                ])
              ])
            ], 2),
            _createVNode(_unref(WebinarList), {
              webinars: _unref(sessionState).webinars,
              "search-criteria": searchCriteria.value,
              "is-loading": _unref(sessionState).isLoading,
              "is-ready": _unref(sessionState).isReady,
              disabled: _unref(sessionState).isRegistering,
              onFilteredWebinarListLengthUpdated: _cache[7] || (_cache[7] = ($event: any) => (filteredWebinarSessionsLength.value = $event))
            }, null, 8, ["webinars", "search-criteria", "is-loading", "is-ready", "disabled"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass(showPastSessionOnly.value ? 'd-none' : 'd-grid')
            }, [
              _createVNode(SessionList, {
                sessions: _unref(sessionState).sessions,
                "search-criteria": searchCriteria.value,
                "micro-filter": microFilter.value,
                "is-loading": _unref(sessionState).isLoading,
                "is-lsat": _unref(sessionState).isLSAT,
                "is-ready": _unref(sessionState).isReady,
                disabled: _unref(sessionState).isRegistering,
                coaches: _unref(coaches),
                "course-tags": _unref(courseTags),
                "show-registered-only": showMySessionOnly.value,
                onFilteredSessionListLengthUpdated: _cache[8] || (_cache[8] = ($event: any) => (filteredSessionsLength.value = $event))
              }, null, 8, ["sessions", "search-criteria", "micro-filter", "is-loading", "is-lsat", "is-ready", "disabled", "coaches", "course-tags", "show-registered-only"]),
              _createElementVNode("h5", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("span", null, " (" + _toDisplayString(filteredPastSessionsLength.value) + ") ", 513), [
                  [_vShow, !_unref(sessionState).isLoading]
                ])
              ])
            ], 2),
            _createVNode(PastSessionList, {
              sessions: _unref(sessionState).sessions,
              "search-criteria": searchCriteria.value,
              "micro-filter": microFilter.value,
              "is-loading": _unref(sessionState).isLoading,
              "is-lsat": _unref(sessionState).isLSAT,
              "is-ready": _unref(sessionState).isReady,
              disabled: _unref(sessionState).isRegistering,
              coaches: _unref(coaches),
              "course-tags": _unref(courseTags),
              onFilteredSessionListLengthUpdated: _cache[9] || (_cache[9] = ($event: any) => (filteredPastSessionsLength.value = $event))
            }, null, 8, ["sessions", "search-criteria", "micro-filter", "is-loading", "is-lsat", "is-ready", "disabled", "coaches", "course-tags"])
          ]))
    ]),
    _createVNode(_unref(SessionRegistration), {
      visible: showSessionRegistration.value,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((showSessionRegistration).value = $event)),
      onCloseModal: _cache[11] || (_cache[11] = ($event: any) => (showSessionRegistration.value = false))
    }, null, 8, ["visible"])
  ], 64))
}
}

})